import { FC, memo } from 'react';
import { ReportTaxesFilterForm, IReportTaxesFilterForm } from './ReportTaxesFilterForm';

export const ReportTaxesFilter: FC<IReportTaxesFilterForm> = memo((props) => (
  <ReportTaxesFilterForm {...props} />
));
